export default "__VITE_ASSET__sRblYROq__"